import CheckBox from "components/check-box";
import GrayCard from "components/gray-card";
import Typography from "components/typography";
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  allChecked: boolean;
  setCheckList: (val: boolean) => void;
}
const CheckList = ({ allChecked, setCheckList }: IProps) => {
  const [firstCheck, setFirstCheck] = useState(allChecked || false);
  const [secondCheck, setSecondCheck] = useState(allChecked || false);
  const [thirdCheck, setThirdCheck] = useState(allChecked || false);
  const [fourthCheck, setFourthCheck] = useState(allChecked || false);

  const AllChecked = useMemo(() => {
    return (
      (firstCheck && secondCheck && thirdCheck && fourthCheck) || allChecked
    );
  }, [firstCheck, secondCheck, thirdCheck, fourthCheck, allChecked]);

  useEffect(() => {
    if (AllChecked) {
      setCheckList(true);
    }
  }, [AllChecked]);
  return (
    <GrayCard title="Important Checklists (Mandatory)">
      <CheckItem>
        <CheckBox
          defaultState={AllChecked}
          onChange={(value) => {
            setFirstCheck(value);
          }}
        />
        <Typography>
          I recorded this music, and I’m authorized to sell it in stores
          worldwide & collect royalties
        </Typography>
      </CheckItem>
      <CheckItem>
        <CheckBox
          defaultState={AllChecked}
          onChange={(value) => {
            setSecondCheck(value);
          }}
        />
        <Typography>
          I’m not using any other artist’s name in my name, song titles, or
          album titles without their approval
        </Typography>
      </CheckItem>
      <CheckItem>
        <CheckBox
          defaultState={AllChecked}
          onChange={(value) => {
            setThirdCheck(value);
          }}
        />
        <Typography>
          I understand that if iI don’t label tracks that contain swear words or
          obscenities correctly , my music video may be rejected from stores
        </Typography>
      </CheckItem>
      <CheckItem>
        <CheckBox
          defaultState={AllChecked}
          onChange={(value) => {
            setFourthCheck(value);
          }}
        />
        <div style={{ display: "flex" }}>
          <Typography>I have read and agreed to Rated Afrika’s</Typography>
          <LinkText to={"/terms-conditions"}>
            <Typography
              decoration="underline"
              color={Colors.yellow500}
              ml="0.4"
            >
              Terms & Conditions
            </Typography>
          </LinkText>
        </div>
      </CheckItem>
    </GrayCard>
  );
};

export default CheckList;

const CheckItem = styled.div`
  display: grid;
  grid-template-columns: 3% 96%;
  align-items: start;
  justify-content: space-between;
  color: ${Colors.grey500};
  margin-bottom: 2.4rem;
`;

const LinkText = styled(Link)`
  all: unset;
  cursor: pointer;
`;
